<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="elisa"><br/><br/><br/><br/><br/><br/><br/>
<p>Elisa was born in Tirana, Albania, in 2007. In 2017, she moved to England. <em>My Fur, My Skin, My Scars</em> is her first book, which she finished writing in 2019.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9611f306